// extracted by mini-css-extract-plugin
module.exports = {"zone_image":"ZoneImage_zone_image__-Dd96"};